module.exports = __webpack_public_path__ + "static/media/hinduja.e966af98.svg";